export class Map {
  constructor() {
    this._houses = null;
    this._maps = document.querySelectorAll(".s-dynamic-map__map svg");

    if (this._maps.length) {
      this.start();
      this.listenerSubmitForm();
    }
  }

  async start(citySearch = null) {
    this.reset();

    this._houses = await this.fetchData(citySearch);

    this._maps.forEach((map) => {
      Object.entries(this._houses).forEach((city) => {
        let path = map.querySelector('path[data-map-city="' + city[0] + '"]');
        if (!path) return;

        city[1].forEach((house, key) => {
          this.drawFloatingBox(path, house, key, city[1].length, citySearch);
        });
      });
    });
  }

  drawFloatingBox(path, house, key, totalHouses, city = null) {
    let gap = 2;
    let padding = 8;

    let floatingBox = document.createElement("div");
    floatingBox.classList.add("floating-box");

    floatingBox.innerHTML = this.buildFloatingBoxTitle(totalHouses, house);

    path.parentNode.parentNode.appendChild(floatingBox);
    let pathRect = path.getBBox();
    let floatingBoxRect = floatingBox.getBoundingClientRect();

    let incrementHeight = (floatingBoxRect.height + gap) * key;

    if (city && city.toLowerCase() === path.getAttribute('data-map-city').toLowerCase()) {
      path.classList.add('active');
    } else {
      path.classList.remove('active');
    }


    floatingBox.style.left = pathRect.x - floatingBoxRect.width / 2 + pathRect.width / 2 + "px";
    floatingBox.style.top = pathRect.y - floatingBoxRect.height / 2 - pathRect.height / 2 - padding - incrementHeight + "px";

    floatingBox.addEventListener("click", (e) => this.drawOverView(house, path, e));

    return floatingBox;
  }

  drawOverView(house, path) {

    document.querySelectorAll(".over-view-box").forEach((box) => {
      box.remove();
    });

    let template = document.querySelector("#over-view-box");
    let clone = template.content.cloneNode(true);

    let title = clone.querySelector(".over-view-box-header__title");
    let address = clone.querySelector(".over-view-box-content__address");
    let phone = clone.querySelector(".over-view-box-content__phone");
    let img = clone.querySelector(".over-view-box-content__image img");
    let link = clone.querySelector("a");

    title.innerHTML = house.city + " - " + house.title;
    address.innerHTML = house.address + ", " + house.postcode;
    phone.innerHTML = house.phone;
    img.src = house.thumbnail_map;
    link.href = house.permalink;

    path.parentNode.parentNode.appendChild(clone);

    if (clone) {
      let pathRect = path.getBBox();
      let box = document.querySelector(".over-view-box");
      let boxRect = box.getBoundingClientRect();

      box.style.left = pathRect.x - boxRect.width / 2 + pathRect.width / 2 + "px";
      box.style.top = pathRect.y - boxRect.height - pathRect.height / 2 + "px";


      this.clickAway();
    }
  }

  clickAway() {
    function handleWindowClick(e) {
      let target = e.target;
      if (!target.closest('.over-view-box') && !target.closest('.floating-box')) {
        document.querySelectorAll(".over-view-box").forEach((box) => {
          box.remove();
        });

        window.removeEventListener('click', handleWindowClick, true);
      }
    }

    window.addEventListener('click', handleWindowClick, true);
  }

  buildFloatingBoxTitle(totalHouses, house) {
    let title = "";

    if (totalHouses === 1) {
      title = house.city;
    } else if (totalHouses === 2) {
      title = house.city + " - " + house.title;
    } else {
      title = house.postcode;
    }

    return title;
  }


  listenerSubmitForm() {
    window.addEventListener('search', (e) => {
      let city = e.detail[0].city;

      this.start(city);
    })
  }

  async fetchData(city = null) {
    let url = "https://fmah.fr/wp-json/akyos/v1/houses";

    if (city) {
      url += `?city=${city}`;
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let res = await response.json();

      const housesByCity = {};
      res.houses.forEach((h) => {
        if (!housesByCity[h.city]) {
          housesByCity[h.city] = [];
        }
        housesByCity[h.city].push(h);
      });

      if (res.houses.length === 0) {
        await this.showEmptyMessage();
      }

      return housesByCity;
    } catch (error) {
      console.error(error.message);
    }
  }

  reset() {
    this._houses = null;

    let emptyHouse = document.querySelector('.empty-house');
    if (emptyHouse) {
      emptyHouse.remove();
    }

    this._maps.forEach((map) => {
      let boxes = map.parentNode.querySelectorAll(".floating-box");
      boxes.forEach(box => {
        box.remove();
      })

      let paths = map.querySelectorAll("path");
      paths.forEach(path => {
        path.classList.remove('active');
      })
    })
  }


  async showEmptyMessage() {
    let template = document.querySelector("#empty-house");
    let clone = template.content.cloneNode(true);

    document.querySelector(".s-dynamic-map__map--main").appendChild(clone);
  }
}
